import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import CustomerView from "./customer_view";
import NetPrompt from "../../../../pacakge/public/module/netprompt/netprompt";
import ModelData, { IUserData } from '../../../public/model_data';
import ModuleManager from "../../../../framework/core/module_manager";
import AppData from "../../../public/const/app_data";
import AppController from "../../../../sdk/app_controller";
import GameUtil from "../../../../utility/game_util";
import Utility from "../../../../utility/utility";
const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit("Customer")
export default class Customer extends ModuleBase<CustomerView, null> {

    constructor() {
        super();
        this.layer = ViewLayer.Mid; 
        this.windowPrefabResPath = "package/hall/module/customer/customer_service";
        this.viewType = CustomerView;
        this.modelType = null;

    }

    protected onButtonClickName(name: string) {

    }

    @bindButtonClickEvent("closeBtn")
    closeWebview() {
        this.hide()
    }

    onShow(intentdata) {
        cc.log("webview,customer intentdata:", intentdata)  //JSON.stringify(jsonObj)
        if(AppData.testMode || true){
            AppController.instance.openLineChat("416bqwqf")
            this.hide()
            return
        }
        
        let url: string = ""
        let isWebview = cc.sys.isNative
        let basePara: string = "/?gameUserId=" + ModelData.instance.roleData.id + "&nickname=" + ModelData.instance.roleData.name + "&headImg=" + ModelData.instance.roleData.avatar + "&gameUserToken=" + ModelData.instance.password + "&language=" + AppData.apiLanguage + "&gameId=" + AppData.gameName + "&deviceOs=" + AppData.devicesOs + "&deviceModel=" + AppData.devicesModel + "&deviceId=" + AppData.devicesId + "&isWebview=" + isWebview
        if (intentdata.customerType == 1) {
            url = AppData.customerServiceUrl + basePara + "&customType=1#/"
        } else if (intentdata.customerType == 3) {
            url = AppData.customerServiceUrl + basePara + "&customType=3#/"
        }
        else if (intentdata.customerType == 2) {
            url = AppData.customerServiceUrl + basePara + "&customType=2"
            let plusPara = ""
            let data = JSON.parse(intentdata.data)
            for (var key in data) {
                plusPara = plusPara + "&" + key + "=" + data[key]
            }
            url = url + plusPara
        } else if (intentdata.customerType == -1) {
            url = intentdata.url
        }
        url = encodeURI(url);
        cc.log("webview,customer url:", url)
        if (CC_JSB) {  //cc.sys.os == cc.sys.OS_ANDROID
            AppController.instance.startWebview(url)
            this.hide()
            return
        }
        if (intentdata.customerType == -1) {
            cc.sys.openURL(url)
            this.hide()
            return
        }
        if (cc.sys.isBrowser) {
            // if (Utility.isFacebook() || Utility.isLine()) {
            //     this.view.webView.url = url
            // } else {
            //     cc.sys.openURL(url)
            //     this.hide()
            // }
            cc.sys.openURL(url)
            this.hide()
        }

    }
}
